export enum Contract_Type {
    SE = 'SALE',
    RT = 'RENT',
}